// Ported from LC2 (src/app/store/reducers/dashboard.js) — same state shape/actions.
// The `coreApiSlice.getChildAccounts` extraReducer matcher is commented out until
// features/coreApi is ported (not needed yet for the shell); re-enable it then.
import {createSlice} from '@reduxjs/toolkit';
// TODO(port coreApi): import {coreApiSlice} from '../../../features/coreApi/apiSlice';

const initialState = {
    account: {sfid: null, name: null},
    community: {sfid: null, name: null},
    campaign: {sfid: null, name: null},
    childAccounts: [],
    campaigns: [],
    communities: []
};

const dashboard = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setDashboard: (state, {payload}) => {
            const {type, data} = payload;
            const lowerCaseType = type.toLowerCase();

            if (lowerCaseType === 'communities') {
                state.community = data;
            } else if (lowerCaseType === 'campaigns') {
                state.campaign = data;
            } else {
                state.account = data;
            }
        },

        setCampaignsSelected: (state, {payload}) => {
            state.campaigns = payload.filter((p) => p.name).sort((a, b) => a.name.localeCompare(b.name));
        },

        setCommunitiesSelected: (state, {payload}) => {
            state.communities = payload;
        }
    }
    // TODO(port coreApi): re-enable once coreApiSlice is ported
    // extraReducers(builder) {
    //     builder.addMatcher(coreApiSlice.endpoints.getChildAccounts.matchFulfilled, (state, action) => {
    //         state.childAccounts = action.payload;
    //     });
    // }
});

export const {setDashboard, setCampaignsSelected, setCommunitiesSelected, setChildAccounts} = dashboard.actions;
export default dashboard.reducer;

export const getDashboardAccount = (state) => state.dashboard.account;
export const getDashboardCommunity = (state) => state.dashboard.community;
export const getDashboardCampaign = (state) => state.dashboard.campaign;
export const getDashboardCampaigns = (state) => state.dashboard.campaigns;
export const getDashboardCommunities = (state) => state.dashboard.communities;
export const getDashboardChildAccounts = (state) => state.dashboard.childAccounts;
